import Input from "../../components/ui/Input";
import Button from "../../components/ui/Button";
import { ReactComponent as Close } from "../../components/ui/styles/Icon_Close.svg";
import { ReactComponent as EditIcon } from "../../components/ui/styles/Icon_Edit.svg";
import Modal from "../../components/ui/Modal";
import { useState } from "react";
import { InputBox, ModalCard, ModalCardBody, ModalCardButtons, ModalCardForm, ModalCardHead, TableActionBtn } from "../domains/UpdateDomainModal";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { updateMailer } from "../../redux/features/PlatformSettingSlice";

const mailerTypes = [{ label: 'SocketLabs', value: 'socketlabs' }, { label: 'ESE', value: 'ese' }];

const UpdateMailerModal = ({ mailer: obj }) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [mailer, setMailer] = useState(obj.mailer);
    const [alias, setAlias] = useState(obj.alias);
    const [domain, setDomain] = useState(obj.domain._id);
    const [type, setType] = useState(obj.type);

    const domains = useSelector(state => state.PlatformSetting.domains).filter((d) => d.active).map((d) => { return ({ label: d.domain, value: d._id }) });

    const mailerNameError = mailer.length < 3 || !alias.length || !domain || !type;

    const close = () => setOpen(false);
    const save = () => {
        dispatch(updateMailer({ id: obj._id, data: { mailer, alias, domain, type } }));
        close();
    }

    return (
        <>

            <TableActionBtn>
                <span
                    onClick={() => setOpen(true)}
                >
                    <EditIcon />
                </span>
            </TableActionBtn>
            <Modal show={open} >
                <ModalCard>
                    <ModalCardHead>
                        <h6>Update mailer</h6>
                        <div style={{ cursor: 'pointer', padding: 10 }} onClick={close}>
                            <Close />
                        </div>
                    </ModalCardHead>
                    <ModalCardBody>
                        <ModalCardForm>
                            <InputBox>
                                <label>Mailer</label>
                                <Input
                                    value={mailer}
                                    onChange={(e) => setMailer(e.target.value)}
                                    style={mailer.length !== 0 && mailer.length < 3 ? {
                                        border: '1px solid #C93E3E'
                                    } : {}}
                                    placeholder="Enter mailer name"
                                />
                            </InputBox>
                            <InputBox>
                                <label>Alias</label>
                                <Input
                                    value={alias}
                                    onChange={(e) => setAlias(e.target.value)}
                                    placeholder="Enter alias"
                                />
                            </InputBox>

                            <div style={{
                                gap: '20px',
                                display: 'flex',
                                flexDirection: 'column'
                            }}>
                                <Select
                                    options={mailerTypes} styles={{
                                        control: (baseStyles) => ({
                                            ...baseStyles,
                                            backgroundColor: '#fff',
                                            borderRadius: '8px',
                                            color: '#4f4f4f',
                                            fontWeight: '',
                                            zIndex: '5000',
                                            cursor: 'pointer'
                                        })
                                    }}
                                    isSearchable={false}
                                    placeholder={'Mailer type'}
                                    defaultValue={mailerTypes.find(e => e.value === type)}
                                    onChange={(v) => setType(v.value)}
                                />
                                <Select
                                    options={domains} styles={{
                                        control: (baseStyles) => ({
                                            ...baseStyles,
                                            backgroundColor: '#fff',
                                            borderRadius: '8px',
                                            color: '#4f4f4f',
                                            fontWeight: '',
                                            zIndex: '5000',
                                            cursor: 'pointer'
                                        })
                                    }}
                                    isSearchable={false}
                                    placeholder={'Domain'}
                                    defaultValue={domains.find(e => e.value === domain)}
                                    onChange={(v) => setDomain(v.value)}
                                />
                            </div>

                        </ModalCardForm>
                        <ModalCardButtons>
                            <Button onClick={close}>
                                Close
                            </Button>
                            <Button
                                disabled={mailerNameError}
                                id="b-login"
                                onClick={save}
                            >
                                Save
                            </Button>
                        </ModalCardButtons>
                    </ModalCardBody>
                </ModalCard>
            </Modal>


        </>

    )
}

export default UpdateMailerModal;